<section id="login" class="bg-light d-flex align-items-center justify-content-center vh-100">
  <div class="container">
    <div class="row">
      <div class="col-sm-10 col-lg-6 col-xl-5 mx-auto">
        <div class="card shadow-sm position-relative p-sm-4 border-0 fade-in-zoom">
          <img src="/images/oktopus-login.webp" alt="" class="position-absolute start-50 translate-middle oktopus"
            loading="lazy">
          <div class="card-body text-center">
            <img src="/images/logo-login.webp" alt="Logo" class="img-fluid mb-3 w-50" loading="lazy">
            <div class="overflow-hidden">
              @if (errorMessage) {
                <div class="alert alert-danger">{{ errorMessage }}</div>
              }
              <div id="formslide" class="d-flex">
                <form class="p-3 w-50" id="formlogin" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                  <div class="mb-3">
                    <div class="input-group">
                      <span class="input-group-text border" id="login-icon"><i class="bi bi-person-fill"></i></span>
                      <input formControlName="email" type="text" class="form-control" id="email"
                        placeholder="Your email"
                        aria-describedby="login-icon"
                        autocomplete="username">
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="input-group">
                      <span class="input-group-text border" id="password-icon"><i class="bi bi-lock-fill"></i></span>
                      <input formControlName="password" type="password" class="form-control" id="password"
                        placeholder="Your password"
                        aria-describedby="password-icon"
                        autocomplete="current-password">
                    </div>
                  </div>
                  <div class="mb-3 text-start">
                    <label><input class="form-check-input me-2" type="checkbox" formControlName="rememberMe"> Remember
                    me next time</label>
                  </div>
                  <div class="d-grid mb-3">
                    <button type="submit" class="btn btn-lg btn-primary text-dark fw-bold p-lg-3" id="signinbtn"
                      [disabled]="loginForm.invalid">Sign In
                    </button>
                  </div>
                  <!--                  <div class="text-center">-->
                  <!--                    <a href="#" class="small" data-bs-toggle="collapse" data-bs-target="#forgotpasswordfield"-->
                <!--                       aria-expanded="false" aria-controls="forgotpasswordfield">Forgot your password ?</a>-->
              <!--                  </div>-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="sticky-bottom">
  <div class="version">{{ getVersion() }}</div>
</div>
</div>
</section>
